<template>
  <div
    v-if="text"
    v-html="text"
  />
</template>

<script lang="ts" setup>
const props = defineProps<{
    text: string
  }>()
</script>
